import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { Observable, Subject } from 'rxjs';
import { AppConstants } from '../../../../SGRE-shared/constants/app-constant';
import { Router } from '@angular/router';
import { CmsService } from '@spartacus/core';
import { selectUserLegalEntities, selectDefaultLegalEntity } from '../../../../SGRE-shared/store/shared-store/selectors/shared.selector';
import { Store, select } from '@ngrx/store';
import { LegalEntity } from '../../../../SGRE-shared/models/legalEntityList.model';
import { StorageService } from '../../../../SGRE-shared/services/storage.service';
@Component({
  selector: 'app-legal-entity-selector',
  templateUrl: './legal-entity-selector.component.html',
  styleUrl: './legal-entity-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LegalEntitySelectorComponent implements OnInit, OnDestroy {

  public legalEntityListSession: string[] = [];
  public selectedLegalEntitySession: LegalEntity;
  public selectedLegalEntity: Observable<LegalEntity>;
  public legalEntityListNew: Observable<string[]>;
  public searchText: string = '';
  public userLoggedIn: Observable<boolean>;
  public searchLegalEntity = "Search Legal Entity";
  private unsubscribe$ = new Subject<void>();

  constructor(
    private globalService: GlobalService,
    private storageService: StorageService,
    private cmsService: CmsService,
    private router: Router,
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.userLoggedIn = this.globalService.loginBanner$;
    this.legalEntityListNew = this.globalService.legalEntitiesList$;
    this.selectedLegalEntity = this.globalService.defaultLegalEntitySubject$;
    // get entities by store select
    this.store.pipe(select(selectUserLegalEntities)).subscribe((userLegalEntities) => {
      this.legalEntityListSession = Array.isArray(userLegalEntities) ? userLegalEntities.map(item => item.name) : [];
    });
    this.store.pipe(select(selectDefaultLegalEntity)).subscribe((defaultLegalEntity) => {
      this.selectedLegalEntitySession = defaultLegalEntity ? defaultLegalEntity : null;
    });
  }

  onValueChange(legalEntityName: string): void {
    if (this.storageService.defaultLegalEntity?.name !== legalEntityName) {
      const uIdVal: string = this.getLegalEntityId(legalEntityName);
      this.globalService._updateLegalEntity(uIdVal);
      this.checkForPageRedirect();
    }
  }

  getLegalEntityId(leName: string): string {
    return this.storageService.userLegalEntities?.find(item => item.name === leName)?.uid || '';
  }

  checkForPageRedirect(): void {
    if (this.router.url?.includes(AppConstants.routeUrls.plp)) {
      this.globalService.clearMessagesOnDestroy();
    } else if (this.router.url?.includes(AppConstants.routeUrls.checkout)) {
      this.router.navigate([AppConstants.routeUrls.plp]);
    } else {
      this.cmsService.refreshLatestPage();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(undefined);
    this.unsubscribe$.complete();
    this.globalService.clearMessagesOnDestroy();
  }
}